import React, {createRef} from 'react';
import "./newevent.css";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { useState } from "react";
import { eventInputs } from "../../formSource";
import axios from 'axios'
import { useNavigate } from "react-router-dom";
import Dropzone from 'react-dropzone';
import { Grid, TextField, Typography, input, Checkbox, Button, Box, Alert, InputLabel, MenuItem, Select, FormControl, FormLabel, RadioGroup, Radio, FormGroup, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Avatar, FormControlLabel } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import PublicIcon from '@mui/icons-material/Public';


const NewEvent = () => {

  const [file, setFile]= useState("")
  const [info, setInfo] = useState({});
  const [inputValues, setInputValues] = useState(['', '', '']);
  const [collapsed, setCollapsed] = useState(false);
  const [photosUrls, setPhotosUrls] = useState([]);
  const [uploadingPhotos, setUploadingPhotos] = useState(false);
  const [socials, setSocials] = useState({});
  const [mapEmbedUrl, setMapEmbedUrl] = useState('');
  

  const citiesData = [
  'Casablanca', 'Rabat', 'Meknès', 'Marrakech', 'Essaouira', 'Fès', 
  'Tanger', 'Agadir', 'Al Hoceïma', 'Chefchaouen', 'Nador', 'Kénitra', 
  'Asilah', 'Tétouan', 'Ifrane', 'Dakhla'
];

const normalizeCity = (city) => {
  return city
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};

// Handlers

  const handleChange = (e) => {
    const { id, value } = e.target;
    
    if (id === 'city') {
      setInfo((prev) => ({ ...prev, [id]: normalizeCity(value) }));
    } else {
      setInfo((prev) => ({ ...prev, [id]: value }));
    }
  };


  const handlePhotosUpload = async (files) => {
      if (!files.length) return;
  
      setUploadingPhotos(true);
  
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('images', files[i]);
      }
  
      try {
        const res = await axios.post('https://api.moroccool.com/api/upload/images', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
  
        setPhotosUrls(prev => [...prev, ...res.data.imageUrls]);
      } catch (err) {
        console.error('Photos upload failed:', err);
      } finally {
        setUploadingPhotos(false);
      }
    };

    const handleRemovePhoto = (indexToRemove) => {
      setPhotosUrls(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    
  const handleInputChange = (index, value) => {
    setInputValues((prevValues) => {
      const newValues = [...prevValues];
      newValues[index] = value;
      return newValues;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Do something with the collected input values
    console.log(inputValues);
  };

  const dropzoneRef = createRef();
  const openDialog = () => {
    // Note that the ref is set async,
    // so it might be null at some point 
    if (dropzoneRef.current) {
      dropzoneRef.current.open()
    }
  };

  const navigate = useNavigate()


  const handleSocialsChange = (e) => {
    const { id, value } = e.target;
    setSocials(prev => ({ ...prev, [id]: value }));
  };

  const handleClick =async e =>{
    e.preventDefault()
    const data= new FormData()
    try{ 
      const newEvent = {
      ...info,
      inputValues,
      photos: photosUrls,
      socials,
      maps:mapEmbedUrl,
      facebook: socials.facebook || '',
      instagram: socials.instagram || '',
      twitter: socials.x || '',
      tiktok: socials.tiktok || '',
      email: socials.email || '',
      website: socials.website || '',
    };

    await axios.post("https://api.moroccool.com/api/events", newEvent)

    }catch(err){
      console.log(err)
    }
    navigate("/events")
  }

  return (
    <div className="mtx__hierarchical__dimensional__container__wrapper__apex">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="dtx__expansive__modular__orchestration__vessel">
        <Navbar/>
        <div className="ctx__supremacist__hierarchical__shadowbox__topmost">
          <h1 className="stx__grandiose__typographic__supremacy__header">Create Your Event</h1>
        </div>

        <div className="etx__magnificent__bifurcated__dimensional__bottommost">
          <form onSubmit={handleSubmit} className="gtx__complete__form__wrapper">
            
            {/* TOP ROW - GALLERY & EVENT INFO */}
            <div className="top__row__container">
              {/* LEFT - GALLERY */}
              <div className="htx__left__gallery__column__zone">
                <div className="gtx__aetheric__chromatic__depositional__gallery__nexus">
                  <h2 className="gallery__title">Event Gallery</h2>
                  <Dropzone
                    onDrop={(acceptedFiles) => handlePhotosUpload(acceptedFiles)}
                    multiple
                    accept="image/*"
                    ref={dropzoneRef}
                    noClick
                    noKeyboard
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div {...getRootProps()} onClick={openDialog} className="htx__phantasmagoric__precipitous__ephemeral__dropzone__apparatus">
                        <input {...getInputProps()} />
                        <CloudUploadOutlinedIcon style={{ fontSize: '3rem', color: '#3b82f6', marginBottom: '1rem' }} />
                        <p>Drop photos here</p>
                        <em>or click to browse</em>
                      </div>
                    )}
                  </Dropzone>

                  {uploadingPhotos && <p className="itx__luminescent__transitory__status__indicator">Uploading photos...</p>}

                  {photosUrls.length > 0 && (
                    <div className="jtx__kaleidoscopic__chromatic__tessellated__preview__constellation">
                      {photosUrls.map((url, index) => (
                        <div key={index} className="vux__image__container__with__delete">
                          <img src={url} alt={`Event photo ${index + 1}`} />
                          <button 
                            type="button"
                            className="vux__delete__button__overlay"
                            onClick={() => handleRemovePhoto(index)}
                            title="Remove image"
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* RIGHT - EVENT INFO */}
              <div className="itx__right__info__column__zone">
                <section className="section__wrapper">
                  <h2 className="section__title">Event Information</h2>
                  {eventInputs.map((input) => {
                    if (input.id === 'city') {
                      return (
                        <div className="ltx__quaternary__demarcated__compositional__form__enclosure" key={input.id}>
                          <label>{input.label}</label>
                          <select
                            onChange={handleChange}
                            id={input.id}
                            value={info[input.id] || ""}
                          >
                            <option value="">Select a city</option>
                            {citiesData.map((city) => (
                              <option key={city} value={normalizeCity(city)}>
                                {city}
                              </option>
                            ))}
                          </select>
                        </div>
                      );
                    }
                    
                    return (
                      <div className="ltx__quaternary__demarcated__compositional__form__enclosure" key={input.id}>
                        <label>{input.label}</label>
                        <input
                          onChange={handleChange}
                          type={input.type}
                          placeholder={input.placeholder}
                          id={input.id}
                          value={info[input.id] || ""}
                        />
                      </div>
                    );
                  })}

                  <div className="mtx__exegetical__verbose__narrative__description__receptacle">
                    <label>Description</label>  
                    <textarea id='description' rows="4" onChange={handleChange} placeholder="Tell us more about your event..."></textarea>
                  </div>
                </section>
              </div>
            </div>

            {/* BOTTOM ROW - LOCATION & SOCIALS */}
            <div className="bottom__row__container">
              {/* LEFT - MAP LOCATION */}
              <div className="left__bottom__section">
                <section className="section__wrapper">
                  <h2 className="section__title">Location</h2>
                  <div className="ltx__quaternary__demarcated__compositional__form__enclosure">
                    <label>Google Maps Embed URL</label>
                    <input
                      type='text'
                      placeholder='Paste your Google Maps iframe src'
                      value={mapEmbedUrl}
                      onChange={(e) => setMapEmbedUrl(e.target.value)}
                    />
                    <small>Example: https://www.google.com/maps/embed?pb=...</small>
                  </div>

                  {mapEmbedUrl && (
                    <div className="ptx__immersive__dimensional__geographic__visualization__container">
                      <iframe
                        src={mapEmbedUrl}
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Map Preview"
                      />
                    </div>
                  )}
                </section>
              </div>

              {/* RIGHT - SOCIAL MEDIA */}
              <div className="right__bottom__section">
                <section className="section__wrapper">
                  <h2 className="section__title">Social Media & Contact</h2>
                  <div className="rtx__synergistic__platform__aggregation__interface">
                    <div className='stx__designated__social__gateway__portal'>
                      <em><FacebookIcon style={{ color: '#1877f2' }} /></em>
                      <input id='facebook' type='text' placeholder='Facebook URL' onChange={handleSocialsChange} />
                    </div>
                    <div className='stx__designated__social__gateway__portal'>
                      <em><InstagramIcon style={{ color: '#e4405f' }} /></em>
                      <input id='instagram' type='text' placeholder='Instagram URL' onChange={handleSocialsChange} />
                    </div>
                    <div className='stx__designated__social__gateway__portal'>
                      <em><TwitterIcon style={{ color: '#1da1f2' }} /></em>
                      <input id='x' type='text' placeholder='Twitter (X) URL' onChange={handleSocialsChange} />
                    </div>
                    <div className='stx__designated__social__gateway__portal'>
                      <em><PublicIcon style={{ color: '#6b7280' }} /></em>
                      <input id='website' type='text' placeholder='Website URL' onChange={handleSocialsChange} />
                    </div>
                    <div className='stx__designated__social__gateway__portal'>
                      <em>📧</em>
                      <input id='email' type='email' placeholder='Contact Email' onChange={handleSocialsChange} />
                    </div>
                    <div className='stx__designated__social__gateway__portal'>
                      <em>🎵</em>
                      <input id='tiktok' type='text' placeholder='TikTok URL' onChange={handleSocialsChange} />
                    </div>
                  </div>
                </section>
              </div>
            </div>

            {/* FEATURED SECTION - FULL WIDTH */}
            <div className="featured__section__full">
              <section className="section__wrapper">
                <h2 className="section__title">Featured Event</h2>
                <div className="utx__binary__selection__prominence__configuration">
                  <label>Make this event featured?</label>
                  <select id="featured" onChange={handleChange}>
                    <option value={false}>No</option>
                    <option value={true}>Yes</option>
                  </select>
                </div>
              </section>
            </div>

            <button onClick={handleClick} className="submit__button__primary">Create Event</button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default NewEvent;